import { Icon, Text } from '@bitrise/bitkit';

import BuildListSkeletonOverlayContent from '../../../components/BuildListItem/BuildListSkeletonOverlayContent';

const BuildListEmptyContent = (): JSX.Element => (
  <BuildListSkeletonOverlayContent textColor="purple.10">
    <Icon name="Build" width="40px" height="40px" />
    <Text size="5" fontWeight="bold">
      You don&apos;t have any builds.
    </Text>
  </BuildListSkeletonOverlayContent>
);

export default BuildListEmptyContent;
